import { render, staticRenderFns } from "./LinkIssues.vue?vue&type=template&id=71989029&"
import script from "./LinkIssues.vue?vue&type=script&lang=js&"
export * from "./LinkIssues.vue?vue&type=script&lang=js&"
import style0 from "./LinkIssues.vue?vue&type=style&index=0&id=71989029&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports